<template>
  <div class="integrations-footer">
    <h4>Heed help getting started?</h4>
    <div class="integrations-footer__links">
      <a
        v-for="link in links"
        :key="link.text"
        :href="link.href"
        :target="link.target"
        class="integrations-footer__link"
      >
        {{ link.text }}
        <i :class="link.iconClass"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'integrations-footer',
  data() {
    return {
      links: [
        // {text: 'View the syncing guide', href: '/', iconClass: 'fas fa-external-link-square-alt'},
        {
          text: 'View the FAQ',
          href: 'https://intercom.help/snappy-kraken/en/',
          iconClass: 'fas fa-question-circle',
          target: '_blank',
        },
        // {text: 'Watch a How To video', href: '/', iconClass: 'fas fa-video'},
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.integrations-footer {
  background: #e0ebeb;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 24px;
  &__links {
    display: block;
    margin: 0 auto;
  }
  &__link {
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    color: #1da5a4;
    font-weight: bold;

    @media (min-width: $breakpoint-sm) {
      display: inline-flex;
      &:not(:last-child) {
        border-right: 1px solid#BDC6C6;
        padding-right: 25px;
        margin-right: 25px;
      }
    }
  }
}
</style>
